/**
 * Плавный переход между страницами.
 *
 * Используется в AppLayout вокруг <Outlet/>; параметр `key` (по `pathname`)
 * заставляет React-tree пересоздаваться, и анимация запускается на каждом
 * переходе.
 */
import type { ReactNode } from 'react';
import Box from '@mui/material/Box';

export function PageTransition({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        animation: 'asubp-page-fade-in 0.18s ease-out',
        '@keyframes asubp-page-fade-in': {
          from: { opacity: 0, transform: 'translateY(4px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
        // Уважать prefers-reduced-motion — дисейблим transform/animation
        '@media (prefers-reduced-motion: reduce)': {
          animation: 'none',
        },
      }}
    >
      {children}
    </Box>
  );
}
